import Vue from 'vue';
import VueRouter from 'vue-router';
import authenticate from "../store";
import config from "../config/constants";


Vue.use(VueRouter);

const routes = [
  /*
      {
          path: '/',
          name: 'home',
          component: () => import('../views/owner/owner_admin_panel.vue'),
          meta: {
              title: 'Sign up',
              requiresAuth: false,
          },
      }, */

  {
    path: '/no-access',
    name: 'no_access',
    component: () => import('../views/no_access.vue'),
    meta: {
      title: 'Sign up',
      requiresAuth: false,
    },
  },
  {
    path: '/landing',
    name: 'landing',
    component: () => import('../views/Landing'),
    meta: {
      title: 'Landing',
      requiresAuth: false,
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/signup/index.vue'),
    meta: {
      title: 'Sign Up for Kiey',
      requiresAuth: false,
    },
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('../views/Mobile'),
    meta: {
      title: 'Mobile',
      requiresAuth: false,
    }
  },
  {
    path: '/disable_email_notifications/:owner_id',
    name: 'disable_email_notifications',
    component: () => import('../views/DisableEmailNotifications'),
    meta: {
      title: 'DisableEmailNotifications',
      requiresAuth: false,
    }
  },
  {
    path: '/chat',
    component: () => import('../Chat.vue'),
    meta: {
      title: 'Home',
      requiresAuth: false,
    },
    children: [
      {
        path: '',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: '',
            name: 'chat',
            component: () => import('../views/chat/chat.vue'),
            meta: {
              title: 'Web Chat',
              requiresAuth: true,
            },
          },
          {
            path: 'home-files',
            name: 'home-files',
            component: () => import('../views/chat/home-files.vue'),
            meta: {
              title: 'Web Home Files',
              requiresAuth: true
            }
          }
        ],
      },
    ]
  },
  {
    path: '',
    component: () => import('../Web.vue'),
    meta: {
      title: 'Home',
      requiresAuth: false,
    },
    children: [
      {
        path: '/sign_up',
        name: 'sign_up',
        component: () => import('../views/owner/sign_up/agent.vue'),
        meta: {
          title: 'Sign up',
          requiresAuth: false,
        },
      },
      {
        // LEGACY — kept as a fallback for any deep-link still pointing at
        // the old two-step flow (account → /sign_up → billing →
        // /sign_up/billing). The current /sign_up page (agent.vue, May
        // 2026 rebuild) collects everything inline via Stripe Elements +
        // POST /v1/signup_owner_with_subscription, so /sign_up/billing
        // is never linked from inside the app. Keep the route + page
        // file alive — they still call the legacy
        // POST /v1/markets/checkout endpoint, which works as-is.
        path: '/sign_up/billing',
        name: 'sign_up.billing',
        component: () => import('../views/owner/sign_up/billing_coming_soon.vue'),
        meta: {
          title: 'Sign up — Billing',
          requiresAuth: false,
        },
      },
      {
        // Stripe Checkout success redirect — `?session_id=cs_...`. Confirms
        // the subscription, then auto-routes to /sign_up/welcome.
        path: '/sign_up/billing/success',
        name: 'sign_up.billing.success',
        component: () => import('../views/owner/sign_up/billing_success.vue'),
        meta: {
          title: 'Sign up — Payment Confirmed',
          requiresAuth: false,
        },
      },
      {
        // Stripe Checkout cancel redirect — user backed out. Lets them retry
        // checkout or return to /sign_up.
        path: '/sign_up/billing/canceled',
        name: 'sign_up.billing.canceled',
        component: () => import('../views/owner/sign_up/billing_canceled.vue'),
        meta: {
          title: 'Sign up — Checkout Cancelled',
          requiresAuth: false,
        },
      },
      {
        // Post-signup landing — owner just registered, point them at the
        // mobile app stores and a secondary link to the admin panel.
        path: '/sign_up/welcome',
        name: 'sign_up.welcome',
        component: () => import('../views/owner/sign_up/download_app.vue'),
        meta: {
          title: 'Welcome to Kiey',
          requiresAuth: false,
        },
      },
      {
        // Public market quote tool — anyone can draw a territory and see its
        // price. No auth, no claim, no billing. CTA routes to /sign_up.
        path: '/my-market',
        name: 'my_market',
        component: () => import('../views/owner/sign_up/market_selection.vue'),
        meta: {
          title: 'Your Market. Your Price.',
          requiresAuth: false,
        },
      },
      {
        // Public Home Value Estimator. Standalone, decoupled from the tenant/agent
        // model — its own Firebase phone login + saved-address history. No auth gate
        // here (handled in-component); the global guard would otherwise force /login.
        path: '/evaluation',
        name: 'evaluation',
        component: () => import('../views/evaluation/index.vue'),
        meta: {
          title: 'Home Value Estimator',
          requiresAuth: false,
        },
      },
      {
        path: '/',
        name: 'login',
        component: () => import('../views/login/index.vue'),
        meta: {
          title: 'Login',
          requiresAuth: false,
        },
      },
      {
        path: '/login',
        name: 'login2',
        component: () => import('../views/login/index.vue'),
        meta: {
          title: 'Login',
          requiresAuth: false,
        },
      },
      {
        path: '/download',
        name: 'download',
        component: () => import('../views/download'),
        meta: {
          title: 'Download Kiey Desktop',
          requiresAuth: false,
        },
      },
      {
        path: '/agent',
        name: 'agent',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'sign_up',
            name: 'agent.sign_up',
            component: () => import('../views/agent/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'sign_up/:referral',
            name: 'agent.sign_up.referral',
            component: () => import('../views/agent/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: '/client',
        name: 'client',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'sign_up',
            name: 'client.sign_up',
            component: () => import('../views/client/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'sign_up/:referral',
            name: 'client.sign_up.referral',
            component: () => import('../views/client/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: '/employee',
        name: 'employee',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'sign_up',
            name: 'employee.sign_up',
            component: () => import('../views/employee/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'sign_up/:referral',
            name: 'employee.sign_up.referral',
            component: () => import('../views/employee/sign_up.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
        ],
      },
      {
        path: '/faqs',
        name: 'faqs',
        component: () => import('../views/faqs.vue'),
        meta: {
          title: 'FAQs',
          requiresAuth: false,
        },
      },
      {
        path: '/terms_and_conditions',
        name: 'terms_and_conditions',
        component: () => import('../views/legal/terms_and_conditions.vue'),
        meta: {
          title: 'Terms and Conditions',
          requiresAuth: false,

        },
      },
      {
        path: '/privacy_policy',
        name: 'privacy_policy',
        component: () => import('../views/legal/privacy_policy.vue'),
        meta: {
          title: 'Privacy Policy',
          requiresAuth: false,
        },
      },
      {
        // Historical: counsel-only preview during the draft phase. The
        // ToS is now live at /terms_and_conditions, so this route just
        // mirrors the same content (raw-markdown <pre> rendering) for
        // anyone hitting an old preview link. No super-admin gate now.
        path: '/terms-preview',
        name: 'terms_preview',
        component: () => import('../views/legal/terms_preview.vue'),
        meta: {
          title: 'Terms of Service',
          requiresAuth: false,
        },
      },
      {
        // Public Data Processing Addendum (DPA). Mirrors the static
        // page at https://kiey.com/dpa.html — fetches the same
        // markdown source (/legal/dpa.md) and renders it inline.
        path: '/dpa',
        name: 'dpa',
        component: () => import('../views/legal/dpa.vue'),
        meta: {
          title: 'Data Processing Addendum',
          requiresAuth: false,
        },
      },
      {
        // Public AI Governance & Impact Assessment. Mirrors the static
        // page at https://kiey.com/ai-governance.html — fetches the same
        // markdown source (/legal/ai_governance.md) and renders it inline.
        path: '/legal/ai-governance',
        name: 'ai_governance',
        component: () => import('../views/legal/ai_governance.vue'),
        meta: {
          title: 'AI Governance',
          requiresAuth: false,
        },
      },
      {
        // Open-source license inventory for the admin.kiey.com app.
        // Mirrors the public-facing kiey.com/licenses page. Reads
        // /legal/licenses.json from /public at runtime — no auth
        // required so the ToS reference works for non-logged-in
        // visitors.
        path: '/legal/open-source-licenses',
        name: 'open_source_licenses',
        component: () => import('../views/legal/open_source_licenses.vue'),
        meta: {
          title: 'Open Source Licenses',
          requiresAuth: false,
        },
      },
      {
        // Forced re-acceptance landing page. Reached via the router
        // beforeEach gate when user.tos_accepted_version drifts from
        // config.tos_current_version after a material ToS update.
        path: '/legal/reaccept',
        name: 'legal.reaccept',
        component: () => import('../views/legal/reaccept.vue'),
        meta: {
          title: 'Updated Terms',
          requiresAuth: true,
        },
      },
      {
        // Privacy Rights Request form. CCPA's "two methods" rule
        // requires a non-email method of submitting privacy
        // requests. Public, no auth required.
        path: '/legal/privacy-request',
        name: 'privacy_request',
        component: () => import('../views/legal/privacy_request.vue'),
        meta: {
          title: 'Privacy Rights Request',
          requiresAuth: false,
        },
      },
      {
        // CCPA-required "Do Not Sell or Share" landing page.
        path: '/legal/do-not-sell',
        name: 'do_not_sell',
        component: () => import('../views/legal/do_not_sell.vue'),
        meta: {
          title: 'Do Not Sell or Share',
          requiresAuth: false,
        },
      },
      {
        // CCPA-required "Limit Use of Sensitive PI" landing page.
        path: '/legal/limit-sensitive-pi',
        name: 'limit_sensitive_pi',
        component: () => import('../views/legal/limit_sensitive_pi.vue'),
        meta: {
          title: 'Limit Use of Sensitive PI',
          requiresAuth: false,
        },
      },
      {
        // Public Cookie Policy.
        path: '/legal/cookie-policy',
        name: 'cookie_policy',
        component: () => import('../views/legal/cookie_policy.vue'),
        meta: {
          title: 'Cookie Policy',
          requiresAuth: false,
        },
      },
      {
        path: '/licenses',
        name: 'licenses',
        component: () => import('../views/Licenses'),
        meta: {
          title: 'Licenses',
          requiresAuth: false,
        }
      },
      {
        path: '/',
        name: 'dashboard',
      },
      {
        path: '/owner',
        name: 'owner',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'sign_up',
            name: 'owner.sign_up.agent',
            component: () => import('../views/owner/sign_up/agent.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'sign_up/:referral',
            name: 'owner.sign_up.agent.referral',
            component: () => import('../views/owner/sign_up/agent.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          // Post-signup add_users / add_vendors flow removed — the owner is
          // now redirected to /sign_up/welcome (the Download App screen). The
          // .vue files remain on disk in case the flow is brought back.
          {
            path: 'vendors',
            name: 'owner.vendors_list',
            component: () => import('../views/owner/vendor/List.vue'),
            meta: {
              title: 'Vendors',
              requiresAuth: true,
            },
          },
          {
            path: 'users',
            name: 'owner.users',
            component: () => import('../views/owner/users/list.vue'),
            meta: {
              title: 'Users',
              requiresAuth: true,
            },
          },
          {
            path: 'users/add-users',
            name: 'owner.users.add',
            component: () => import('../views/owner/users/addUser.vue'),
            meta: {
              title: 'Add User',
              requiresAuth: true,
            },
          },
          {
            path: 'owner-onboarding',
            name: 'owner.onboarding',
            component: () =>
              import('../views/owner/onboarding/owner_onboarding.vue'),
            meta: {
              title: 'Add Users',
              requiresAuth: true,
            },
          },
          {
            path: 'owner-admin-panel',
            name: 'owner.dashboard',
            component: () => import('../views/owner/owner_admin_panel.vue'),
            meta: {
              title: 'Admin panel',
              requiresAuth: true,
            },
          },
          {
            path: 'vendors/add',
            name: 'owner.vendors.add',
            component: () => import('../views/owner/vendor/AddVendor.vue'),
            meta: {
              title: 'Add Vendors',
              requiresAuth: true,
            },
          },
          {
            path: 'vendor-coverage',
            name: 'owner.vendor_coverage',
            component: () => import('../views/owner/vendor_coverage/index.vue'),
            meta: {
              title: 'Vendor Coverage',
              requiresAuth: true,
            },
          },
          {
            path: 'vendor-recommendations',
            name: 'owner.vendor_recommendations',
            component: () => import('../views/owner/vendor_recommendations/list.vue'),
            meta: {
              title: 'Vendor Recommendations',
              requiresAuth: true,
            },
          },
          {
            path: 'clients',
            name: 'owner.clients',
            component: () => import('../views/owner/clients/list.vue'),
            meta: {
              title: 'Homeowners',
              requiresAuth: true,
            },
          },
          {
            path: 'marketing',
            name: 'owner.marketing',
            component: () => import('../views/owner/marketing/index.vue'),
            meta: {
              title: 'Marketing',
              requiresAuth: true,
            },
          },
          {
            // Sign-up Links has been folded into the Marketing tab. Keep the
            // old path working (and any links pointing at it) by redirecting.
            path: 'signup-sources',
            name: 'owner.signup_sources',
            redirect: { name: 'owner.marketing' },
          },
          {
            path: 'alerts',
            name: 'owner.alerts',
            component: () => import('../views/owner/alerts/list.vue'),
            meta: {
              title: 'Alerts',
              requiresAuth: true,
            },
          },
          // {
          //   path: 'reports',
          //   name: 'owner.reports',
          //   component: () => import('../views/owner/reports/List.vue'),
          //   meta: {
          //     title: 'Reports',
          //     requiresAuth: true,
          //   },
          // },
          {
            path: 'invoices',
            name: 'owner.invoices',
            component: () => import('../views/owner/invoices/List.vue'),
            meta: {
              title: 'Invoice',
              requiresAuth: true,
            },
          },
          {
            path: 'sms-logs',
            name: 'owner.sms-logs',
            component: () => import('../views/owner/sms_logs/list.vue'),
            meta: {
              title: 'SMS Logs',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'business-logic',
            name: 'owner.business-logic',
            component: () => import('../views/business-logic/index.vue'),
            meta: {
              title: 'Business Logic Reference',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'app-version-management',
            name: 'owner.app-version-management',
            component: () => import('../views/owner/app_version_management/index.vue'),
            meta: {
              title: 'App Version Management',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'marketing-console',
            name: 'owner.marketing_console',
            component: () => import('../views/owner/marketing/super_console.vue'),
            meta: {
              title: 'Marketing Console',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'onboarding',
            name: 'owner.onboarding',
            component: () => import('../views/owner/deployment/index.vue'),
            meta: {
              title: 'Onboarding Tracker',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'tenants',
            name: 'owner.tenants',
            component: () => import('../views/owner/tenants/list.vue'),
            meta: {
              title: 'Tenants',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'invited-users',
            name: 'owner.invited_users',
            component: () => import('../views/owner/invited_users/list.vue'),
            meta: {
              title: 'Invited Users',
              requiresAuth: true,
            },
          },
          {
            path: 'invited-users-all',
            name: 'owner.invited_users_all',
            component: () => import('../views/owner/invited_users/all.vue'),
            meta: {
              title: 'Invited Users (All)',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'signup-waitlist',
            name: 'owner.signup_waitlist',
            component: () => import('../views/owner/signup_waitlist/index.vue'),
            meta: {
              title: 'Sign-Up Waitlist',
              requiresAuth: true,
              requiresSuperUser: true,
            },
          },
          {
            path: 'supports',
            name: 'owner.supports',
            component: () => import('../views/owner/support/add.vue'),
            meta: {
              title: 'Support',
              requiresAuth: true,
            },
          },
          {
            path: 'account',
            name: 'owner.account',
            component: () => import('../views/owner/billing/list.vue'),
            meta: {
              title: 'Account',
              requiresAuth: true,
            },
          },
          {
            path: 'crm',
            name: 'owner.crm',
            component: () => import('../views/owner/crm/index.vue'),
            meta: {
              title: 'CRM',
              requiresAuth: true,
            },
          },
          {
            path: 'billing',
            name: 'owner.billing',
            component: () => import('../views/owner/billing/list.vue'),
            meta: {
              title: 'Billing',
              requiresAuth: true,
            },
          },
          // {
          // 	path: 'custom',
          // 	name: 'owner.custom',
          // 	component: () => import('../views/owner/Custom.vue'),
          // 	meta: {
          // 		title: 'Settings',
          // 		requiresAuth: true,
          // 	},
          // },
        ],
      },
      {
        path: '/vendor',
        name: 'vendor',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'sign_up',
            name: 'vendor.sign_up',
            component: () => import('../views/vendor/sign_up/register.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'sign_up/:referral',
            name: 'vendor.sign_up.referral',
            component: () => import('../views/vendor/sign_up/register.vue'),
            meta: {
              title: 'Sign up',
              requiresAuth: false,
            },
          },
          {
            path: 'billing',
            name: 'vendor.billing',
            component: () => import('../views/vendor/billing/list.vue'),
            meta: {
              title: 'Account',
              requiresAuth: true,
            },
          },
          // {
          //   path: 'report',
          //   name: 'vendor.report',
          //   component: () => import('../views/vendor/ReportUsers.vue'),
          //   meta: {
          //     title: 'Report',
          //     requiresAuth: true,
          //   },
          // },
          {
            path: 'support',
            name: 'vendor.support',
            component: () => import('../views/vendor/SupportUsers.vue'),
            meta: {
              title: 'Support',
              requiresAuth: true,
            },
          },
          {
            path: 'vendor-admin-panel',
            name: 'vendor.dashboard',
            component: () => import('../views/vendor/vendor_admin_panel.vue'),
            meta: {
              title: 'Admin Panel',
              requiresAuth: true,
            },
          },
          {
            path: 'app-display-information',
            name: 'vendor.app-display-info',
            component: () => import('../views/vendor/AppDisplayInformation.vue'),
            meta: {
              title: 'Display',
              requiresAuth: true,
            },
          },
          {
            path: 'users',
            name: 'vendor.users',
            component: () => import('../views/vendor/users/list.vue'),
            meta: {
              title: 'Users',
              requiresAuth: true,
            },
          },
          {
            path: 'users/add-users',
            name: 'vendor.users.add',
            component: () => import('../views/vendor/users/addUser.vue'),
            meta: {
              title: 'Add Users',
              requiresAuth: true,
            },
          },
          {
            path: 'invoices',
            name: 'vendor.invoices',
            component: () => import('../views/vendor/invoices/List.vue'),
            meta: {
              title: 'Invoice',
              requiresAuth: true,
            },
          },
        ],
      },
    ]
  },

];

const router = new VueRouter({
  mode: 'history',
  // VUE_APP_ROUTER_BASE lets the kiey.com subpath bundle ship assets at
  // publicPath '/my-market-app/' while routing URLs as '/my-market' (Firebase
  // hosting rewrites /my-market -> /my-market-app/index.html, so the browser
  // URL bar stays '/my-market' — Router base must match that, not publicPath).
  base: process.env.VUE_APP_ROUTER_BASE || process.env.BASE_URL,
  routes,
});

router.beforeEach((toRoute, fromRoute, next) => {

  // if (toRoute.name === 'mobile') {
  //   next();
  //   return;
  // }
  // let routes_excluded = ['landing', 'client.sign_up.referral', 'vendor.sign_up.referral'];
  // if (mobile() && !routes_excluded.includes(toRoute.name)) {
  //   next('/mobile');
  // }
  // next();
  // Don't override title on chat routes — totalUnread computed manages it
  if (toRoute.name !== 'chat' && toRoute.name !== 'home-files') {
    window.document.title =
      'Kiey' +
      (toRoute.meta && toRoute.meta.title ? ' - ' + toRoute.meta.title : '');
  }

  if (["kiey.local", "www.kiey.local", "kiey.com", "www.kiey.com", "staging.kiey.com"].includes(window.location.hostname) && toRoute.name === 'login') {
    next('/landing');
  } else if (["web.kiey.local", "web.kiey.com"].includes(window.location.hostname) && toRoute.name !== 'chat' && toRoute.name !== 'home-files') {
    next('/chat');
  } else {
    if (toRoute.name === 'dashboard') {
      if (authenticate.getters['Authenticate/isLoggedIn']) {
        if (authenticate.getters['Authenticate/userRole'] === 'owner') {
          // Cancelled tenant: admins land on /owner/billing (Reactivate
          // card), non-admin sub-users land on /owner/account (read-only
          // + Data Export). Active tenant: normal admin panel.
          if (!authenticate.getters['Authenticate/paymentPermission'])
            next(authenticate.getters['Authenticate/is_tenant_admin'] ? '/owner/billing' : '/owner/account');
          else
            next('/owner/owner-admin-panel');
        } else if (authenticate.getters['Authenticate/userRole'] === 'vendor') {
          if (!authenticate.getters['Authenticate/paymentPermission'])
            next('/vendor/billing');
          else
            next('/vendor/vendor-admin-panel');
        } else {
          next('/login');
        }
      } else {
        next('/login');
      }
    } else if (['login', 'login2'].includes(toRoute.name) && authenticate.getters['Authenticate/isLoggedIn']) {
      const user = authenticate.getters['Authenticate/current_user'];
      if (!user) { authenticate.dispatch('Authenticate/safety_logout'); next(); return; }

      if (user.user_role === 'vendor' || (user.user_role === 'employee' && user.is_admin)) {
        if (!user['first_login'] && user.user_role !== 'agent') {
          if (!authenticate.getters['Authenticate/paymentPermission'])
            next('/vendor/billing');
          else
            next('/vendor/vendor-admin-panel');
        } else {
          if (!authenticate.getters['Authenticate/paymentPermission'])
            next('/vendor/billing');
          else
            next('/vendor/vendor-admin-panel');
        }

      } else if (user.user_role === 'owner' || user.user_role === 'super_user' || (user.user_role === 'agent' && user.is_admin)) {
        // Post-signup add_users/add_vendors flow has been removed; both
        // branches now land on the admin panel. If the tenant is
        // cancelled: admins → /owner/billing (Reactivate), non-admin
        // sub-users → /owner/account (read-only + Data Export).
        if (!authenticate.getters['Authenticate/paymentPermission'])
          next(authenticate.getters['Authenticate/is_tenant_admin'] ? '/owner/billing' : '/owner/account');
        else
          next('/owner/owner-admin-panel');
      }

      return;

    } else if (toRoute.matched.some((record) => record.meta.requiresAuth)) {
      // Chat routes handle their own auth (QR code login) — let them through
      if (["chat", "home-files"].includes(toRoute.name)) {
        next();
        return;
      }
      if (!authenticate.getters['Authenticate/isLoggedIn']) {
        next('/login');
        return;
      }
      if (authenticate.getters['Authenticate/isLoggedIn']) {
        const user = authenticate.getters['Authenticate/current_user'];
        if (!user) { next(); return; }
        // Forced ToS re-acceptance gate. Fires only when the in-memory
        // user's accepted version drifts from config.tos_current_version
        // — bumping that constant pushes every existing user through
        // /legal/reaccept on their next navigation. Also fires when the
        // user has NO recorded acceptance at all (null / undefined),
        // which catches invited Vendors / Homeowners / Employees who
        // activate via the login flow (activate.js) without an explicit
        // ToS checkbox — they get prompted on first web navigation,
        // accept once, and proceed. Mobile-only users never see this
        // gate (it's web-router-only). Skip when the user is already on
        // /legal/reaccept (avoid redirect loop) or when they're
        // navigating to /terms* / privacy_policy (let them read what
        // they're being asked to accept).
        const exemptNames = new Set([
          'legal.reaccept',
          'terms_and_conditions',
          'privacy_policy',
          'terms_preview',
          'dpa',
          'ai_governance',
          'open_source_licenses',
          'licenses',
          // Privacy-rights routes must always be reachable, even
          // when the user hasn't re-accepted the latest ToS — a
          // user can't be required to re-accept terms in order to
          // exercise CCPA / GDPR rights.
          'privacy_request',
          'do_not_sell',
          'limit_sensitive_pi',
          'cookie_policy',
        ]);
        if (
          !exemptNames.has(toRoute.name) &&
          user.tos_accepted_version !== config.tos_current_version
        ) {
          next({ path: '/legal/reaccept', query: { redirect: toRoute.fullPath } });
          return;
        }

        // Role-based route scoping: prevent cross-role access.
        // Exception: /owner/account is reachable by EVERY role, because
        // when a tenant is hard-cancelled the lockout routes vendor /
        // employee sub-users to /owner/account for read-only Data
        // Export. Without this exception, the role-scoping bounces
        // them to /vendor/vendor-admin-panel, the cancelled-tenant
        // guard re-routes them back to /owner/account, and the two
        // guards loop indefinitely.
        const role = user.user_role;
        const path = toRoute.path;
        if (
          path.startsWith('/owner/')
          && !['owner', 'agent', 'super_user'].includes(role)
          && toRoute.name !== 'owner.account'
        ) {
          next('/vendor/vendor-admin-panel');
          return;
        }
        if (path.startsWith('/vendor/') && !['vendor', 'employee', 'super_user'].includes(role)) {
          next('/owner/owner-admin-panel');
          return;
        }
        if (
          toRoute.matched.some((record) => record.meta.requiresSuperUser) &&
          user.user_role !== 'super_user'
        ) {
          next('/owner/owner-admin-panel');
          return;
        } else if (
          !authenticate.getters['Authenticate/paymentPermission'] &&
          !["owner.account", "owner.billing", "vendor.billing"].includes(toRoute.name)
        ) {
          // Cancelled-tenant lockout routing.
          //   - Tenant admins (owner / agent admin / super_user) →
          //     /owner/billing, where the Reactivate card lives.
          //   - A vendor-tenant owner (user.owner_id === tenant.owner_id
          //     AND user_role === 'vendor') → legacy /vendor/billing
          //     for their OWN cancelled vendor subscription.
          //   - Everyone else (vendor sub-users in someone else's
          //     cancelled tenant, employees, non-admin agents) →
          //     /owner/account, where the form goes read-only and
          //     Data Export stays available. Vendors-as-sub-users do
          //     NOT have their own subscription, so /vendor/billing
          //     would imply a billing relationship they don't have.
          // Allow-list (owner.account / owner.billing / vendor.billing)
          // means those three pages can host a cancelled session
          // without the guard bouncing it back here in a loop.
          const isTenantAdmin = authenticate.getters['Authenticate/is_tenant_admin'];
          if (isTenantAdmin && user.user_role === 'vendor') {
            next('/vendor/billing');
          } else if (isTenantAdmin) {
            next('/owner/billing');
          } else {
            next('/owner/account');
          }
        } else if (["vendor.users", "vendor.users.add", "vendor.app-display-info"]
          .includes(toRoute.name) && authenticate.getters['Authenticate/userRole'] === 'vendor') {
          if (!authenticate.getters['Authenticate/accountEnabledPermission']) {
            next('/vendor/billing');
          } else {
            next();
          }
        } else
          next();

        return;
      }
      next('/login');

    } else {
      next();
    }
  }
});

router.onError((error) => {
  console.error('Router navigation error:', error);
  // Prevent white screen on navigation failure in restricted WebViews
  if (error.name === 'NavigationDuplicated') return;
});

export default router;
